exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg-primary-pink{background-color:#f8264d!important}.bg-primary-violet{background-color:#7a00ff!important}@media only screen and (min-width:768px){section.hero-header .top h1{font-size:8rem!important}}section.hero-header{border-bottom:12px solid #333;position:relative;flex-direction:column;align-items:initial;text-align:center}section.hero-header .top{flex-grow:1;background:#3c3c3c;border-bottom:4px solid #7a00ff}section.hero-header .top h1,section.hero-header .top p{color:#fff;text-shadow:0 0 10px #0f0f0f}section.hero-header .top h1{font-size:5rem}section.hero-header .top p{font-size:2rem}section.hero-header .bottom{flex-grow:3;background:#fff}section.hero-header .bottom .key-distribute{position:relative;flex-grow:1}section.hero-header .bottom .key-distribute>div{background:#2c2c2c;width:40%;height:50%;margin:0 auto;z-index:10;position:relative}section.hero-header .bottom .key-distribute>span{height:100%;width:1px;background:#ccc;position:absolute;top:0;left:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/HeroHeader.less
// module id = 314
// module chunks = 0